import { useTranslation } from "react-i18next"

const Title = ({ title }: { title: string }) => {
  const { t } = useTranslation()
  return <p className="text-2xl text-primary font-bold">{t(title)}</p>
}
export default Title
